import { render } from "./TrainingAttendingView.vue?vue&type=template&id=47ff7e22&scoped=true"
import script from "./TrainingAttendingView.vue?vue&type=script&lang=js"
export * from "./TrainingAttendingView.vue?vue&type=script&lang=js"

import "./TrainingAttendingView.vue?vue&type=style&index=0&id=47ff7e22&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ff7e22"]])

export default __exports__